import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";
import { redirectToLogout } from "../lib/auth";

const Logout = () => {
  const { hardShutdown } = useIntercom();

  useEffect(() => {
    hardShutdown();
    redirectToLogout();
  }, [hardShutdown]);

  return null;
};

export default Logout;
